import { render, staticRenderFns } from "./AppNavItem.vue?vue&type=template&id=8bc9712c&scoped=true&"
import script from "./AppNavItem.vue?vue&type=script&lang=ts&"
export * from "./AppNavItem.vue?vue&type=script&lang=ts&"
import style0 from "./AppNavItem.vue?vue&type=style&index=0&id=8bc9712c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc9712c",
  null
  
)

export default component.exports